import { LocalStorageDataModel } from "../../constants/local-storage-data-model";
import { Env, getDataFromLocalStorage } from "../../utils/globalUtilities";
import axios from "axios";
const unauthorizedCode = [401];

export const TaxPracticeBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_NODE_TAX_PRACTICE_URL,
});
TaxPracticeBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("TaxmannAuthorization");
    let machineId: any = getDataFromLocalStorage(LocalStorageDataModel.MACHINE_ID_NEW);
    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
        [LocalStorageDataModel.MACHINE_ID]: machineId
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

TaxPracticeBaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && unauthorizedCode.includes(response.status)) {
      // logoutUserSession()
    }
    return Promise.reject(error);
  }
);
